export default (namespace) => ({
  cannotInsureHome: {
    id: `${namespace}.cannotInsureHome`,
    defaultMessage: 'We are sorry but we cannot insure your home',
  },
});
